module.exports = __webpack_public_path__ + "img/HK.fa3dc4ea.png";